import { createSlice, PayloadAction } from '@reduxjs/toolkit';

//This is agents from database, we could change logic in backend.
interface PersonContactState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: PersonContactState = {
  data: [],
  isLoading: false,
  error: null,
};

const personContactSlice = createSlice({
  name: 'personContact',
  initialState,
  reducers: {
    setContactPersons: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setContactPersonsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setContactPersonsError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setContactPersons, setContactPersonsLoading, setContactPersonsError } = personContactSlice.actions;

export default personContactSlice.reducer;
